import { render } from "./section-footer-detail-payment.vue?vue&type=template&id=5587345c&scoped=true&ts=true"
import script from "./section-footer-detail-payment.vue?vue&type=script&lang=ts"
export * from "./section-footer-detail-payment.vue?vue&type=script&lang=ts"

import "./section-footer-detail-payment.vue?vue&type=style&index=0&id=5587345c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5587345c"]])

export default __exports__